import React from 'react';

// Importar ojos variados
import ojo2 from '../images/ilustrations/Anye_Ojo2.svg';
import ojo3 from '../images/ilustrations/Anye_Ojo3.svg';
import ojo4 from '../images/ilustrations/Anye_Ojo4.svg';
import ojo5 from '../images/ilustrations/Anye_Ojo5.svg';
import ojo6 from '../images/ilustrations/Anye_Ojo6.svg';
import ojo7 from '../images/ilustrations/Anye_Ojo7.svg';
import ojo8 from '../images/ilustrations/Anye_Ojo8.svg';
import ojo9 from '../images/ilustrations/Anye_Ojo9.svg';
import ojo10 from '../images/ilustrations/Anye_Ojo10.svg';
import ojo11 from '../images/ilustrations/Anye_Ojo11.svg';
import ojo12 from '../images/ilustrations/Anye_Ojo12.svg';
import ojo13 from '../images/ilustrations/Anye_Ojo13.svg';
import ojo14 from '../images/ilustrations/Anye_Ojo14.svg';
import ojo15 from '../images/ilustrations/Anye_Ojo15.svg';

// Posiciones agrupadas alrededor de la imagen central, como en la referencia
// Los ojos forman un arco envolvente concentrado arriba y a los lados
const duration = 4; // Duración constante para sincronización perfecta

const eyes = [
  // Arco Superior (Alineados y alternados)
  { src: ojo6,  left: '32%', top: '10%',   width: 75, delay: 0 },
  { src: ojo2,  left: '29%', top: '10%',   width: 75, delay: duration / 2 },
  { src: ojo4,  left: '41%', top: '9%',   width: 75, delay: 0 },
  { src: ojo3,  left: '44%', top: '12%',   width: 60, delay: duration / 2 },
  { src: ojo5,  left: '53%', top: '3%',   width: 60, delay: 0 },
  { src: ojo6,  left: '59%', top: '14%',   width: 70, delay: duration / 2 },
  { src: ojo7,  left: '65%', top: '20%',   width: 70, delay: 0 },
  { src: ojo8,  left: '62%', top: '12%',   width: 65, delay: duration / 2 },
  { src: ojo9,  left: '56.5%', top: '8%',   width: 65, delay: 0 },
  { src: ojo10, left: '50%', top: '10%',   width: 65, delay: duration / 2 },

  // // Laterales (Lluvia de ojos)
  { src: ojo11, left: '39%', top: '4%',  width: 55, delay: 0 },
  { src: ojo12, left: '25%', top: '17%',  width: 95, delay: duration / 2 },
  { src: ojo13, left: '49%', top: '12%',  width: 57, delay: 0 },
  { src: ojo14, left: '46%', top: '5%',  width: 55, delay: duration / 2 },
  { src: ojo15, left: '37%', top: '15%',  width: 56, delay: 0 },
];

function FloatingEyes() {
  return (
    <div
      className="FloatingEyes"
      aria-hidden="true"
      style={{
        position: 'absolute',
        inset: 0,
        zIndex: 2,
        pointerEvents: 'none',
        overflow: 'hidden',
      }}
    >
      {eyes.map((eye, i) => (
        <img
          key={i}
          src={eye.src}
          alt=""
          className="FloatingEyes-eye"
          style={{
            position: 'absolute',
            left: eye.left,
            top: eye.top,
            width: eye.width,
            height: 'auto',
            objectFit: 'contain',
            opacity: 0.8,
            animationDuration: `${duration}s`,
            animationDelay: `${eye.delay}s`,
          }}
        />
      ))}
    </div>
  );
}

export default FloatingEyes;
